import { logger } from '@/utils/log';
import { EVENT_TYPES, on as emitterOn, off as emitterOff } from '@/utils/event-emitter.js';
// cross-origin support
import { safeParentCall, safeParentSet, safeParentGet } from '@/utils/crossOriginHelper';

export const only = (obj = {}, keys = []) => {
  if (typeof keys === 'string') {
    keys = keys.split(/\s+/);
  }

  return keys.reduce((ret, key) => {
    if (obj[key] != null) {
      ret[key] = obj[key];
    }
    return ret;
  }, {});
};

const REQUIRED_MESSAGE_KEYS = ['type', 'message', 't', 'errorCode', 'errorMessage', 'codeErrMsg', 'errorMsg'];

const REQUIRED_PLAN_KEYS = [
  'parent_category',
  'category',
  'plan_code',
  'billing_cycle',
  'selected_number',
  'capacity',
  'trialCode',
  'trialDays',
  'campaignCode',
  'isOnlineFreeTrial',
];

const REQUIRED_KEYS_NAMES = {
  email: 'email',
  flowType: 'flowType',
  url: 'url',
  boughtPlans: 'boughtPlans',
  cartProducts: 'cartProducts',
  messages: 'messages',
};

const STRING_KEYS = [REQUIRED_KEYS_NAMES.email, REQUIRED_KEYS_NAMES.flowType, REQUIRED_KEYS_NAMES.url];

const OBJECT_KEYS = [REQUIRED_KEYS_NAMES.boughtPlans, REQUIRED_KEYS_NAMES.cartProducts, REQUIRED_KEYS_NAMES.messages];

const REQUIRED_MESSAGE_TYPE_KEYS = ['error', 'warning'];

const isZVAInChat = async () => {
  try {
    const [isInit, isChatting] = await Promise.all([
      safeParentGet('zoomCampaignSdk.isInit'),
      safeParentGet('zoomCampaignSdk.isChatting')
    ]);
    return isInit && isChatting;
  } catch (error) {
    console.warn('Failed to check ZVA chat status:', error);
    return false;
  }
};


class MessageMonitorForZVA {
  constructor() {
    // this.sessionStorageKey = 'OPC/__INFO_FOR_ZVA__';
    this._data = null;
    this._eventListeners = []; // Store event listeners for cleanup
  }
  init(email = '') {
    this.log('init MessageMonitorForZVA, email: ', email);
    this.initData(email);

    this.initEventListener();
  }
  initEventListener() {
    // Define all event listeners in an array
    const eventListeners = [
      {
        eventType: EVENT_TYPES.URL_CHANGE,
        callback: (url) => {
          this.log(EVENT_TYPES.URL_CHANGE, url);
          this.updateUrl(url);
        },
      },
      {
        eventType: EVENT_TYPES.BOUGHT_PLANS_UPDATE,
        callback: (plans) => {
          this.log(EVENT_TYPES.BOUGHT_PLANS_UPDATE, plans);
          this.updateBoughtPlans(plans);
        },
      },
      {
        eventType: EVENT_TYPES.PERSIST_UPDATE,
        callback: (plans) => {
          this.log(EVENT_TYPES.PERSIST_UPDATE, plans);
          this.updateCartProducts(plans);
        },
      },
      {
        eventType: EVENT_TYPES.EMAIL_UPDATE,
        callback: (email) => {
          this.log(EVENT_TYPES.EMAIL_UPDATE, email);
          this.updateEmail(email);
        },
      },
      {
        eventType: EVENT_TYPES.API_ERROR,
        callback: (data) => {
          this.log(EVENT_TYPES.API_ERROR, data);
          this.addMessages(data);
        },
      },
      {
        eventType: EVENT_TYPES.POLLING_ERROR,
        callback: (data) => {
          this.log(EVENT_TYPES.POLLING_ERROR, data);
          this.addMessages(data);
        },
      },
      {
        eventType: EVENT_TYPES.UI_MESSAGE,
        callback: (data) => {
          if (REQUIRED_MESSAGE_TYPE_KEYS.includes(data.type)) {
            this.log(EVENT_TYPES.UI_MESSAGE, data);
            this.addMessages(data);
          }
        },
      },
      {
        eventType: EVENT_TYPES.UI_ALERT,
        callback: (data) => {
          if (REQUIRED_MESSAGE_TYPE_KEYS.includes(data.type)) {
            this.log(EVENT_TYPES.UI_ALERT, data);
            this.addMessages(data);
          }
        },
      },
      {
        eventType: EVENT_TYPES.UI_GLOBAL_ALERT,
        callback: (data) => {
          this.log(EVENT_TYPES.UI_GLOBAL_ALERT, data);
          this.addMessages(data);
        },
      },
      {
        eventType: EVENT_TYPES.ZVA_CLEAR_DATA,
        callback: () => {
          this.log(EVENT_TYPES.ZVA_CLEAR_DATA);
          this.clearData();
        },
      },
    ];

    // Register all event listeners and store references
    this._eventListeners = eventListeners.map(({ eventType, callback }) => {
      emitterOn(eventType, callback);
      return { eventType, callback };
    });
  }
  initData(email = '') {
    this._data = {
      email: email,
      flowType: window?.$context?.flow || '',
      url: location.href,
      boughtPlans: [
        // {
        //   parent_category: "PRO",
        //   category: "PRO",
        //   plan_code:"zo_pro_yearly",
        //   billing_cycle: "annual",
        //   selected_number: 1,
        //   capacity: null,
        //   // for Free Trial === start ===
        //   trialCode: null,
        //   trialDays: null,
        //   campaignCode: null,
        //   // for Free Trial === end ===
        //   isOnlineFreeTrial: false,
        // }, {
        //     parent_category: "ZWB",
        //     category: "zwbbasic",
        //     plan_code:"zwb_monthly",
        //     billing_cycle: "monthly",
        //     selected_number: 1,
        //     capacity: null,
        //     // for Free Trial === start ===
        //     trialCode: null,
        //     trialDays: null,
        //     campaignCode: null,
        //     isOnlineFreeTrial: false,
        //     // for Free Trial === end ===
        // }
      ],
      cartProducts: [
        // {
        //   parent_category: "WBN",
        //   category: "webinar500",
        //   plan_code: "webinar500_monthly",
        //   billing_cycle: "monthly",
        //   selected_number: 1,
        //   capacity: "500",
        //   // for Free Trial === start ===
        //   trialCode: "zoom_webinar_monthly_trial_service",
        //   trialDays: 14,
        //   campaignCode: "zoom_webinar_500",
        //   // for Free Trial === end ===
        //   isOnlineFreeTrial: true,
        // }
      ],
      messages: [
        // {
        //   type: 'warning',
        //   message: 'this is a warning message'
        // },{
        //   type: 'error',
        //   message: 'this is a error message'
        // },{
        //   errorCode: xxx,
        //   message: 'this is a error message' // errorMessage || errorMsg
        // }
      ], // append-only, no deletions, during connection session
    };
  }
  clearData() {
    this._data = null;

    // Remove all event listeners
    this._eventListeners.forEach(({ eventType, callback }) => {
      emitterOff(eventType, callback);
    });
    this._eventListeners = [];

    this.clearStorage();
  }
  noticeZVA() {
    this.log('noticeZVA');
    // cross-origin support
    safeParentCall('zoomCampaignSdk.updateUserContext');
  }
  updateEmail(email) {
    this.updateData({
      key: REQUIRED_KEYS_NAMES.email,
      value: email,
    });
  }
  updateUrl(url) {
    this.updateData({
      key: REQUIRED_KEYS_NAMES.url,
      value: url,
    });
  }
  updateBoughtPlans(boughtPlans) {
    this.updateData({
      key: REQUIRED_KEYS_NAMES.boughtPlans,
      value: boughtPlans.map((boughtPlan) => only(boughtPlan, REQUIRED_PLAN_KEYS)),
    });
  }
  updateCartProducts(cartProducts) {
    this.updateData({
      key: REQUIRED_KEYS_NAMES.cartProducts,
      value: cartProducts.map((cartProduct) => only(cartProduct, REQUIRED_PLAN_KEYS)),
    });
  }
  addMessages(message) {
    message.t = message.t ?? Date.now();
    this.updateData({
      key: REQUIRED_KEYS_NAMES.messages,
      value: only(message, REQUIRED_MESSAGE_KEYS),
    });
  }
  updateData({ key, value }) {
    this.log(`updateData ${key}:`, value);
    if (!this._data) {
      logger.warn('[MessageMonitorForZVA] Cannot update data: _data is null');
      return;
    }
    if (STRING_KEYS.includes(key)) {
      this.log(`update ${key} to`, value);
      this._data[key] = value;
    } else if (OBJECT_KEYS.includes(key)) {
      this.log(`add ${key}:`, value);
      if (Array.isArray(value)) {
        this._data[key] = value;
      } else {
        this._data[key].push(value);
      }
    } else {
      this.log('error key to update');
      return;
    }
    this.updateStorage();
    isZVAInChat().then(isInChat => {
      if (isInChat) {
        this.noticeZVA();
      }
    }).catch(error => {
      console.warn('Failed to check ZVA chat status:', error);
    });
  }
  updateStorage() {
    // sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(this._data));
    // cross-origin support
    safeParentSet('OPC_INFO_FOR_ZVA', this._data);
  }
  clearStorage() {
    // sessionStorage.removeItem(this.sessionStorageKey);
    // cross-origin support
    safeParentSet('OPC_INFO_FOR_ZVA', null);
  }
  log(...args) {
    logger.log('MessageMonitorForZVA: ', ...args);
  }
}
const messageMonitorForZVA = new MessageMonitorForZVA();

export default messageMonitorForZVA;
